import React, { useState } from 'react';
import { getDonneTelechargementDate } from './ConnectionBDD';

function convertirDate(dateStr) {
    const [annee, mois, jour] = dateStr.split('-');
    return `${jour}/${mois}/${annee}`;
}

const TelechargementDonnee = () => {
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [organisation, setOrganisation] = useState('');
    const [email, setEmail] = useState('');

    const handleDownloadButtonClick = async (e) => {
        e.preventDefault();

        try {
            // Appeler la fonction pour récupérer les données CSV
            //console.log(convertirDate(startDate), convertirDate(endDate), organisation, email);

            const csvData = await getDonneTelechargementDate(convertirDate(startDate), convertirDate(endDate), organisation, email);

            // Créer un lien de téléchargement
            const blob = new Blob([csvData], { type: 'text/csv' });
            const url = URL.createObjectURL(blob);
            const downloadLink = document.getElementById('downloadLink');
            downloadLink.href = url;
            downloadLink.download = 'weather_data_cefe '+startDate+' - '+endDate+ '.csv';

            // Afficher le lien de téléchargement et simuler le clic
            //downloadLink.style.display = 'block';
            downloadLink.click();

            // Nettoyer l'URL créée
            URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Erreur lors de la récupération des données:', error);
        }


    };

    return (
        <div className="box">

            <h2>Téléchargement des données automatiques</h2>
            <h2>(01 Janvier 2014 - Aujourd'hui)</h2>
            <form id="dataForm" onSubmit={handleDownloadButtonClick}>
                <label htmlFor="startDate">Date de début :</label>
                <input type="date" id="startDate" name="startDate" value={startDate}
                       min="2014-01-01"
                       max={new Date().toISOString().split('T')[0]}
                       onChange={(e) => setStartDate(e.target.value)} required/>


                <label htmlFor="endDate">Date de fin :</label>
                <input type="date" id="endDate" name="endDate" value={endDate}
                       min="2014-01-01"
                       max={new Date().toISOString().split('T')[0]}         // date maximale = aujourd'hui
                    onChange={(e) => setEndDate(e.target.value)}
                    required
                />

                <label htmlFor="organisation">Organisation :</label>
                <input type="text" id="organisation" name="organisation" value={organisation}
                       onChange={(e) => setOrganisation(e.target.value)} required/>

                <label htmlFor="email">Email :</label>
                <input type="email" id="email" name="email" value={email} onChange={(e) => setEmail(e.target.value)}
                       required/>



                <label><input type="checkbox" id="terms" name="terms" required/> J'ai lu et j'accepte les conditions d'utilisation ci-dessous</label>

                <button type="submit">Télécharger les données</button>

            </form>
            <a id="downloadLink" href="#" style={{display: 'none'}}>Cliquez ici pour télécharger les données</a>
        </div>
    );
};



export default TelechargementDonnee;
